import React from "react";
import SkypeGroupList from "../../../UI/Groups/Skype/View/SkypeGroupList";

const SkypeGroup = () => {
  return (
    <div>
      <SkypeGroupList />
    </div>
  );
};

export default React.memo(SkypeGroup);
